<template>
  <v-layout
    column
    data-cy="weekdays-picker"
  >
    <v-layout
      class="mb-2"
      align-center
    >
      <span
        v-if="showLabel"
        class="grey--text text--darken-2"
      >
        {{ $t('weekdays') }}
      </span>
      <span
        v-if="showWorkdaysButton || showSaturdayButton"
        class="ml-5 pl-3"
      >
        <span
          v-if="showWorkdaysButton"
          class="pseudo-anchor grey--text caption unselectable"
          @click="$emit('update:weekdays', [0, 1, 2, 3, 4])"
        >
          {{ $t('weekdaysPresetWorkdays') }}</span>
        <span
          v-if="showSaturdayButton"
          class="ml-2 pseudo-anchor grey--text caption unselectable"
          @click="$emit('update:weekdays', [5])"
        >
          {{ $t('weekdaysPresetSaturday') }}</span>
      </span>
    </v-layout>
    <v-layout>
      <v-layout
        v-for="weekdayIndex in allWeekdayIndices"
        :key="weekdayIndex"
        column
        align-center
        style="max-width: 36px"
        :data-cy="'weekday-checkbox-' + weekdayIndex"
      >
        <v-checkbox
          :input-value="isWeekdayIndexSelected(weekdayIndex)"
          color="msr"
          class="weekdays-checkbox"
          hide-details
          @change="onWeekdayIndexToggled(weekdayIndex)"
        />
        <span
          style="width: 36px"
          class="pl-1 pt-2"
          :class="{'msr--text': isWeekdayIndexSelected(weekdayIndex)}"
        >
          <v-label>
            {{ allWeekdayNameAbbreviations[weekdayIndex] }}
          </v-label>
        </span>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import {
  ALL_WEEKDAY_INDICES,
  getAllWeekdayNameAbbreviations,
} from '@/mixins/weekdays';

export default {
  props: {
    /**
     * Array of weekday indices e.g.: [0, 1, 2, 3, 4] or [5].
     *
     * This is meant to be synced.
     */
    weekdays: {
      type: Array[Number],
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showWorkdaysButton: {
      type: Boolean,
      default: false,
    },
    showSaturdayButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    allWeekdayIndices() {
      return ALL_WEEKDAY_INDICES;
    },
    allWeekdayNameAbbreviations() {
      return getAllWeekdayNameAbbreviations();
    },
  },
  methods: {
    isWeekdayIndexSelected(weekdayIndex) {
      return this.weekdays.indexOf(weekdayIndex) !== -1;
    },
    onWeekdayIndexToggled(weekdayIndex) {
      const currentlySelected = this.isWeekdayIndexSelected(weekdayIndex);
      const newSelected = !currentlySelected;

      let newWeekdays = this.weekdays.slice();
      if (newSelected) {
        newWeekdays.push(weekdayIndex);
        newWeekdays.sort();
      } else {
        const position = newWeekdays.indexOf(weekdayIndex);
        newWeekdays.splice(position, 1);
      }

      this.$emit('update:weekdays', newWeekdays);
    },
  },
};
</script>

<style scoped>
.weekdays-checkbox.v-input--selection-controls {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/WeekdaysPicker.vue